import createCardListingView from '../Views/createCardListingView';
import FlexPeopleCard from './FlexPeopleCard';

// People cards are portrait tiles in their own responsive grid, so the
// generic Grid layout setting doesn't apply.
export default createCardListingView(FlexPeopleCard, {
  displayName: 'PeopleListingView',
  containerClass: 'cards__container--people',
  supportsGrid: false,
});
